import { useState } from 'react';
import { Layout, Image, Typography, Grid, Col, Row, Flex, Card, Drawer, Button, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';

import ESCUDOS_INSTITUCIONALES from "./../../../../../../assets/images/escudos/EDOMEX_EDU_CONA.png";
import GUIA_RAPIDA_EGRESADOS from "./../../../../../../assets/guias/egresados/guia_rapida_egresados.pdf";
import RegistrationForm from './../registrationForm/RegistrationForm';
import { useLogin } from "../hooks/HookLogin";


const { Header } = Layout;
const { useBreakpoint } = Grid;

export default function AuthLayout() {
    const screens = useBreakpoint(); // Hook para obtener el estado de las pantallas
    const { error } = useLogin();
    const [drawerVisible, setDrawerVisible] = useState(false);
    const showDrawer = () => setDrawerVisible(true);
    const closeDrawer = () => setDrawerVisible(false);


    const TituloEgresados = () => {
        return (
            <>
                <Typography.Title level={3}>
                    ¡Hola!👋🏻 Bienvenidos al
                </Typography.Title>
                <Typography.Text style={{ fontWeight: 'bold', color: '#9F2241' }}>
                    Sistema de Seguimiento de Egresados
                </Typography.Text>
                <div style={{ marginBottom: '3vh' }}></div>
            </>
        );
    };


    return (
        <>
            <Header style={{ backgroundColor: '#f6fafaff', padding: '0 16px' }}>
                <Row justify="space-between" align="middle" gutter={[16, 0]}>
                    {/* Columna para el logo */}
                    <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                        <Image
                            src={ESCUDOS_INSTITUCIONALES}
                            preview={false}
                            alt="logotipo Conalep"
                            width="100%"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </Col>
                    {/* Columna para el título */}
                    {screens.md || screens.lg || screens.xl ? <Col xs={24} sm={12} md={16} lg={14} xl={14}>
                        <Typography.Title
                            level={screens.xs || screens.sm ? 5 : 4} // Reducir el tamaño del título en móviles
                            strong
                            style={{
                                color: '#9F2241',
                                fontSize: screens.xs || screens.sm ? '16px' : '1.5vw', // Ajuste del tamaño de la fuente
                                textAlign: 'right', // Alinear texto a la izquierda en dispositivos grandes
                                marginTop: 0,
                                wordBreak: 'break-word',
                                lineHeight: 1.2,
                            }}
                        >
                            Sistema de Seguimiento de Egresados
                        </Typography.Title>
                    </Col> : null}
                </Row>
            </Header>
            <Flex justify="center" align="center" style={{ minHeight: '80vh' }}>
                <Row>
                    <Col>
                        <Card
                            style={{
                                minWidth: 400,        // Ancho mínimo
                                minHeight: 300,       // Altura mínima
                                maxWidth: '90vw',     // Máximo 90% del ancho de pantalla
                                width: '400px',        // Se ajusta al contenido
                                height: '600px',       // Se ajusta al contenido
                                boxShadow: '8px 8px 0px #9F2241', // x-offset y-offset blur color
                                border: '2px solid #f0f0f0',      // Borde sutil
                            }}>
                            <Row>
                                <Col span={24}>
                                    <TituloEgresados />
                                </Col>
                            </Row>
                            <main>
                                <Outlet />
                            </main>


                            {error &&
                                <Col span={24} align="center">
                                    <Typography.Title level={5} type='danger'>
                                        {error}
                                    </Typography.Title>
                                </Col>}
                            <Col span={24} align="center">
                                <Typography.Text>
                                    ¿No tienes una cuenta? <a href="#" onClick={showDrawer}>Regístrate</a>
                                </Typography.Text>

                                <Drawer
                                    title="Registro de Egresados"
                                    placement="right"
                                    onClose={closeDrawer}
                                    open={drawerVisible}
                                    width={600}
                                    destroyOnHidden={true}
                                    style={{ backgroundColor: '#f6fafaff' }}
                                    extra={
                                        <Space>
                                            <Button icon={<CloseOutlined />} onClick={closeDrawer}>Cancelar registro</Button>
                                        </Space>
                                    }
                                    footer={
                                        <Row justify="center">
                                            <Col>
                                                <Space>
                                                    <Button icon={<CloseOutlined />} onClick={closeDrawer}>Cerrar registro</Button>
                                                </Space>
                                            </Col>
                                        </Row>
                                    }
                                >
                                    <RegistrationForm onClose={closeDrawer} />
                                </Drawer>
                            </Col>
                            {/*<Col span={24} style={{ textAlign: 'center' }}>
                                <Typography.Link href="/empresas/inicio-sesion">¿Eres una empresa?</Typography.Link>
                            </Col>*/}
                            <Col span={24} style={{ textAlign: 'center' }}>
                                <Typography.Link
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={GUIA_RAPIDA_EGRESADOS}
                                >
                                    Guía rápida
                                </Typography.Link>
                            </Col>
                        </Card>
                    </Col>
                </Row>
            </Flex>
        </>
    );
}